import IconButton from 'components/atoms/Button/IconButton';
import LeftSettingMenu from 'components/molecules/LeftSettingMenu';
import SideMenu from 'components/molecules/SideMenu';
import { disableAllMenu, isActiveSettingMenu, isActiveSideMenu } from 'modules/actions/statusMenu';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
/**
 * Chatting:Header
 */
const ChatHeader = ({ title, viewType }) => {
  const settingMenuStatus = useSelector(state => state.isActive.settingMenu);
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);

  const dispatch = useDispatch();

  // 채팅창 닫기
  const eventClickBackMain = () => {
    console.log(5555);
  };

  const onClickOut = () => {
    dispatch(disableAllMenu());
  };
  /* 셋팅매뉴 클릭시 다른 메뉴창 닫힘 */
  const onSettingMenu = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isActiveSettingMenu());
  };

  /* 사이드메뉴 클릭시 다른 메뉴창 닫힘 */
  const onSideMenu = () => {
    if (settingMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isActiveSideMenu());
  };
  return (
    <header className="_chat_header" style={{ zIndex: settingMenuStatus || sideMenuStatus ? 3 : 2 }}>
      <div className="_left_div">
        <IconButton
          icon="ri-settings-3-line"
          styleDef={{
            borderRadius: '0px',
            color: '#fff',
            transform: settingMenuStatus ? 'rotate(90deg)' : 'rotate(0deg)',
            opacity: settingMenuStatus ? '1' : '0.5',
            transition: settingMenuStatus ? '0.5s' : '0.5s',
            fontSize:'30px'
          }}
          viewStatus=""
          clickEvt={onSettingMenu}
        />
      </div>
      <div className="_center_div">
        <div className="_logo">
          <img src="/images/logo.png" alt="logo" />
        </div>
        <div className="_title" onClick={() => window.location.reload()} style={{cursor:'pointer'}}>
          <p>인천광역시 서해구 상담사 서동이</p>
        </div>
      </div>
      <div className="_right_div">
        <IconButton icon="ri-question-line" styleDef={{ borderRadius: '0px', color: '#FFF', fontSize: '30px' }} viewStatus="" clickEvt={onSideMenu} />
      </div>
      <LeftSettingMenu styleDef={{ height: settingMenuStatus ? '150px' : '0px' }} />
      <div className="setting" style={{ display: settingMenuStatus ? 'block' : 'none' }} onClick={() => onClickOut()} />
      {/* <div className="setting_side" style={{ display: sideMenuStatus ? 'block' : 'none' }} onClick={() => onClickOut()} /> */}
      <SideMenu styleDef={{ display: sideMenuStatus ? 'flex' : 'none' }} />
    </header>
  );
};

ChatHeader.propTypes = {
  title: PropTypes.string,
  viewType: PropTypes.string,
};
ChatHeader.defaultProps = {
  title: '',
  viewType: '',
};
export default ChatHeader;
